/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OtmId } from 'common-typescript/types';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SlideBanner } from 'sis-components';
import { StudentOpenUniversityProductAccessTokenService } from '../../../common/service/student-open-university-product-access-token.service';
import { AggregateProductInfo } from '../types';

@Pipe({
    name: 'productSlideBanner',
    standalone: false,
})
export class ProductSlideBannerPipe implements PipeTransform {
    constructor(
        private accessTokenService: StudentOpenUniversityProductAccessTokenService,
        private translate: TranslateService,
    ) {}

    transform(product: AggregateProductInfo): Observable<SlideBanner[]> {
        if (!product?.id) {
            return of([]);
        }

        const { id, isInCart, isFull, requiresAccessToken } = product;
        return this.accessTokenService
            .getAccessTokenForProduct(id)
            .pipe(
                map(accessToken =>
                    [
                        isInCart ? this.inCartBanner(id) : null,
                        requiresAccessToken && !isInCart
                            ? accessToken
                                ? this.validAccessTokenLinkBanner(id)
                                : this.requiresAccessTokenLinkBanner(id)
                            : null,
                        isFull ? this.noSeatsBanner(id) : null,
                    ].filter(Boolean),
                ),
            );
    }

    private inCartBanner(productId: OtmId): SlideBanner {
        return new SlideBanner(
            `${productId}_banner_in-cart`,
            'success',
            this.translate.instant('OPEN_UNIVERSITY.STUDY_OFFERING.ADDED_TO_CART'),
        );
    }

    private noSeatsBanner(productId: OtmId): SlideBanner {
        return new SlideBanner(
            `${productId}_banner_no-seats`,
            'danger',
            this.translate.instant('OPEN_UNIVERSITY.STUDY_OFFERING.NO_SEATS_AVAILABLE'),
        );
    }

    private requiresAccessTokenLinkBanner(productId: OtmId): SlideBanner {
        return new SlideBanner(
            `${productId}_banner_requires-access-token`,
            'danger',
            this.translate.instant('OPEN_UNIVERSITY.STUDY_OFFERING.REQUIRES_ACCESS_TOKEN_LINK'),
        );
    }

    private validAccessTokenLinkBanner(productId: OtmId): SlideBanner {
        return new SlideBanner(
            `${productId}_banner_valid-access-token`,
            'success',
            this.translate.instant('OPEN_UNIVERSITY.STUDY_OFFERING.VALID_ACCESS_TOKEN_LINK'),
        );
    }
}
